import './assets/main.less'
import './assets/pc.less'
import './assets/h5.less'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/drawer/style/css'
import 'vant/es/floating-bubble/index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
// import i18n from './i18n'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
// app.use(i18n)

app.mount('#app')
